import { Link, useLocation } from "react-router-dom";
import { useMall } from "@/context/MallContext";

/**
 * The minimap. One pill, on every page, that says which of the three places you're standing in:
 * the white-label sales pages, the directory, or one shop (its color). The demo gets its own word.
 */
const WHITE_LABEL = ["/whitelabel", "/spaces", "/pitch", "/open-space"];

export function ZoneChip({ zone: forced, className = "" }) {
    const { store, solo, site, demo, theme } = useMall();
    const { pathname } = useLocation();

    let zone = forced;
    if (!zone) {
        if (demo) zone = "demo";
        else if (solo && site?.store) zone = "shop";
        else if (store) zone = "shop";
        else if (pathname === "/" || WHITE_LABEL.some((p) => pathname.startsWith(p))) zone = "white-label";
        else zone = "directory";
    }

    const shop = solo && site?.store ? site.store : store;
    const styles = {
        "white-label": { label: "White-label", to: "/whitelabel", style: { background: "#2563EB", color: "#fff" } },
        directory: { label: "Directory", to: "/directory", style: { background: "#18181B", color: "#fff" } },
        demo: { label: "Demo", to: "/whitelabel", style: { background: "#F59E0B", color: "#0B0B0B" } },
        shop: {
            label: shop?.name ? `Shop · ${shop.name}` : "Shop",
            to: shop?.slug ? `/stores/${shop.slug}` : "/directory",
            style: { background: theme?.primary || "#18181B", color: theme?.on || "#fff" },
        },
    }[zone];

    return (
        <Link to={styles.to} data-testid="zone-chip" data-zone={zone} title="Where you are on 13thav"
            className={`inline-flex max-w-[11rem] shrink-0 items-center gap-1.5 truncate rounded-full px-2.5 py-1 font-mono text-[11px] font-bold uppercase tracking-[0.14em] ${className}`}
            style={styles.style}>
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-current opacity-80" />
            <span className="truncate">{styles.label}</span>
        </Link>
    );
}
